import { useRouter } from 'next/router';
import { ErrorComponent } from '../components/error';
import type { PageWithContext } from '../lib/utils/context';
const NotFoundPage: PageWithContext = () => {
  const router = useRouter();
  return <ErrorComponent statusCode={404} asPath={router.asPath} data-sentry-element="ErrorComponent" data-sentry-component="NotFoundPage" data-sentry-source-file="404.tsx" />;
};
export default NotFoundPage;